var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdobepremiere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "Adobe Premiere Pro icon"), /*#__PURE__*/React.createElement("path", {
    d: "M6.297 5.778c0-.066.016-.116.099-.116.643-.033 1.584-.05 2.574-.05 2.772 0 3.976 1.519 3.976 3.466 0 2.54-1.838 3.63-4.099 3.63-.379 0-.511-.017-.775-.017v3.843c0 .083-.033.116-.116.116H6.412c-.082 0-.115-.033-.115-.116zm1.775 5.313c.231.016.412.016.808.016 1.172 0 2.268-.412 2.268-1.996 0-1.27-.783-1.914-2.119-1.914-.396 0-.776.016-.957.033zm6.4-.908c0-.115 0-.412-.05-.973 0-.083.012-.1.078-.132a10.42 10.42 0 0 1 3.656-.693c.083 0 .116.016.116.099v1.452c0 .082-.027.099-.11.099-.626-.033-1.544.05-1.89.198v6.301c0 .083-.033.116-.116.116h-1.569c-.082 0-.115-.033-.115-.116zM0 .3v23.4h24V.3zm1 1h22v21.4H1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobepremiere);
export default __webpack_public_path__ + "static/media/adobepremiere.8ce8a7d9e2f7931775fa61b43d16f212.svg";
export { ForwardRef as ReactComponent };